import { useState } from 'react';
import { sendTestEmail } from '../../services/emailNotifications';

export default function EmailSettingsPanel() {
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');

  async function handleTest() {
    setSending(true);
    setMessage('');
    try {
      await sendTestEmail();
      setMessage('The email function accepted the test request. Check the inbox to confirm delivery.');
    } catch (error) {
      setMessage(`Test failed: ${error.message}. Check that the Supabase Edge Function is deployed and its SMTP secrets are configured.`);
    } finally {
      setSending(false);
    }
  }

  return (
    <section className="admin-card">
      <div className="admin-card-heading"><span>SETTINGS</span><h2>Email notifications</h2></div>
      <p>Send a test notification to kandsons.com@gmail.com.</p>
      <div className="admin-actions">
        <button className="button button-gold" type="button" disabled={sending} onClick={handleTest}>
          {sending ? 'Sending…' : 'Send Test Email'}
        </button>
        <span role="status">{message}</span>
      </div>
    </section>
  );
}